<template>
  <div>
    <div style="width:50%;  display: inline-block;">
      <Select
      :placeholder="placeholder"
      clearable
      :multiple="multiple"
      :value="parentValue"
      @on-change="changeParent"
    >
      <template v-for="item1 in items">
        <Option
          :key="item1.id"
          :value="item1.id"
          :label="item1.name"
          :disabled="!selectParent"
        >
          {{ item1.name }}
        </Option>
      </template>
    </Select>
    </div>


    
    <div style="width:50%;display: inline-block;">
      <Select
      :placeholder="placeholder"
      clearable
      :multiple="multiple"
      :value="value"
      @on-change="changeChildren"
    >
      <template v-for="item1 in childrenItems">
        <Option
          :key="item1.id"
          :value="item1.id"
          :label="item1.name"
          :disabled="!selectParent"
        >
          {{ item1.name }}
        </Option>
      </template>
    </Select>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Model from "../../models/admin/categories";
import arrayToTree from "array-to-tree";

@Component({
  props: {
    placeholder: {
      type: String,
      default: "请选择分类"
    },
    alias: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectParent: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String, Number],
      default: ""
    },
    parentValue: {
      type: [Array, String, Number],
      default: ""
    }
  },
  computed:{
    childrenItems() {
      let parentId = this.parentValue;
      let cl = this.items.filter(i => {
        return i['id'] == parentId;
      });

      if (cl.length > 0) {
        cl = (cl[0] && cl[0]['children']) || [];
      }

      console.log("calc", cl);

      return cl;
    }
  }
})
export default class CategorySelect2 extends Vue {
  items = [];
  itemsIdx = -1;

  async created() {
    const getRes = await new Model().GET({
      query: {
        where: {
          alias: this.alias,
          schoolId: this.getSchoolId()
        }
      }
    });

    this.parentValue = this.value;

    this.items = arrayToTree(getRes.data.items, {
      parentProperty: "parentId"
    });

    const tval = getRes.data.items.filter(i => i['id'] == this.value);
    this.parentValue = (tval[0] && tval[0]['parentId']) || 0;
    console.log("one parentValue", this.parentValue);

  }
  changeParent(value) {
    this.$emit("change", {
      parentValue: value,
      value: value,
    });
    this.parentValue = value;
  }

  changeChildren(value) {
    const parentValue = this.parentValue;
    console.log(value, parentValue);
    this.$emit("change", {
      parentValue: parentValue,
      value: value,
    });
  }
}
</script>
